import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {FrapperService} from "./frapper.service";
import {AssignedService} from "./assigned.service";
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DemandesAvisService {

  Doctype_Demande_avis ='liste avis'

  constructor(private http: HttpClient, private frapper: FrapperService,private authservice: AuthService, private assigneService:AssignedService) {}


 // Demande
  async getAllDemandeAvis(filter =null) {
    try {
      let avis = await this.frapper.GetDoctypes(this.Doctype_Demande_avis,'["*"]',filter).toPromise()
      console.log('resp api Doctype_Signature ===> ', avis)
      return avis
    } catch (error) {
      this.authservice.handleError(error)
    }

  }
 
  async getOneDemandeAvis(name) {
    try {
      let demande = await this.frapper.GetDoctype(this.Doctype_Demande_avis,name,'["*"]',null).toPromise()
    //console.log('My Courriers Principale ===> ', my_courriers)
    return demande
    } catch (error) {
      this.authservice.handleError(error)
    }

  }


  async nouvelleDemandeAvis(body) {
    try {
      let avis = await this.frapper.CreateDoctype(this.Doctype_Demande_avis,body).toPromise()
      return avis
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async updateDemandeAvis(docname,body){
    try {
      let result = this.frapper.UpdateDoctype(this.Doctype_Demande_avis,docname,body).toPromise()
      return result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }


}
